/*
 *
 * Chat actions
 *
 */

import {
  GET_INBOX_DETAIL,
  GET_CONVERSATION_LIST,
  GET_CONVERSATION_DETAIL,
  SEND_CONVERSATION_MESSAGES,
  UPDATE_CONVERSATION_MESSAGES,
  START_BOOK_MEETING,
  GET_CONVERSATION_LIST_FILTERED,
  REMOVE_CONVERSATION_DETAIL,
  GET_TEAM_MEMBERS,
  GET_CONVERSATION_MEMBERS,
  SET_ARCHIVE_STAR_CONVERSATION,
  UPDATE_CONVERSATION_LIST,
  UPDATE_INBOX_DETAIL_STATISTICS,
  ADD_NEW_MEMBER_CONVERSATION,
  REMOVE_MEMBER_CONVERSATION,
  READ_CONVERSATION,
  UPDATE_CONVERSATION_STATUS,
  UPDATE_INBOX_DATA,
  CHANGE_CURRENT_CONVERSATION,
  GET_USER_STATUS,
  UPDATE_USER_STATUS,
  LOADING_NEW_CONVERSATION,
  GET_CONVERSATION_FROM_PARAMS,
  CLOSE_SELECTED_CONVERSATION,
  SET_CONVERSATION_REQUEST,
  ADD_TO_CONVERSATIONS_LIST,
  REMOVE_FROM_CONVERSATIONS_LIST,
  UPDATE_SENDING_MESSAGES,
  HANDLE_SENDING_MESSAGE_TO_PUSHER,
  REMOVE_FROM_SENDING_MESSAGES,
  UPDATE_MESSAGE_READ_STATUS,
  UPDATE_MESSAGE_DELIVERED,
  IS_UPDATE_CONVERSATION_LISTS,
  POLL_BACKEND,
  UPDATE_CONVERSATION_DETAILS,
  GET_CANNED_MESSAGES,
  SAVE_CANNED_MESSAGE,
  DELETE_CANNED_MESSAGE,
  EDITOR_HAS_CONTENT,
  HAS_NEW_MESSAGES,
  SEND_MESSAGE,
  HAS_SEND_MESSAGE,
  SET_CUSTOM_FILTER,
  CHANGE_ZENDESK_INBOX_ACTIVE_TAB,
  CREATE_ZENDESK_TICKET,
  GET_KNOWLEDGE_BASE_ARTICLES,
  GET_CONNECTED_APPS,
  LOGOUT_USER,
  UPDATE_INBOX_STATISTICS,
  UPDATE_CONVERSATIONS_READ,
  UPDATE_SELECTED_FILTERS,
  CREATE_SERVICE_CLOUD_CASE,
  GET_SERVICE_CLOUD_ARTICLES,
  CHANGE_SERVICE_CLOUD_ACTIVE_TAB,
  GET_TAGS,
  GET_SUBSCRIPTION_DETAILS,
  GET_HIGHLIGHTS_FIELDS,
  GET_HIGHLIGHTS_TEMPLATES,
  SAVE_HIGHLIGHTS_BUILDER,
  UPDATE_SELECTED_FIELDS_COUNT,
  BLOCK_VISITOR,
  OPEN_VISITOR_BLOCK_MODAL,
  UPDATE_CONVERSATION_LIST_FILTERS,
  GET_ATTACHMENTS,
  UPDATE_ATTACHMENTS,
  UPDATE_UPLOAD_PROGRESS,
} from './constants';
import { defineAction } from 'utils/action-helper';

export const setCustomFilter = ({ metadata, data }) => {
  return defineAction({
    type: SET_CUSTOM_FILTER,
    metadata,
    payload: { data },
  });
};

export const getCannedMessages = {
  start: ({ metadata }) => defineAction({ type: GET_CANNED_MESSAGES.START, metadata }),
  success: ({ data }) => defineAction({ type: GET_CANNED_MESSAGES.SUCCESS, payload: { data } }),
  error: ({ error }) =>
    defineAction({
      type: GET_CANNED_MESSAGES.ERROR,
      error,
    }),
};

export const saveCannedMessage = {
  start: ({ metadata }) => defineAction({ type: SAVE_CANNED_MESSAGE.START, metadata }),
  success: ({ data }) => defineAction({ type: SAVE_CANNED_MESSAGE.SUCCESS, payload: { data } }),
  error: ({ error }) =>
    defineAction({
      type: SAVE_CANNED_MESSAGE.ERROR,
      error,
    }),
};

export const deleteCannedMessage = {
  start: ({ metadata }) => defineAction({ type: DELETE_CANNED_MESSAGE.START, metadata }),
  success: ({ data }) => defineAction({ type: DELETE_CANNED_MESSAGE.SUCCESS, payload: { data } }),
  error: ({ error }) =>
    defineAction({
      type: DELETE_CANNED_MESSAGE.ERROR,
      error,
    }),
};

export const pollBackend = ({ metadata }) => {
  return defineAction({
    type: POLL_BACKEND,
    metadata,
  });
};

export const updateConversationDetails = () => {
  return defineAction({
    type: UPDATE_CONVERSATION_DETAILS,
  });
};

export const setEditorHasContent = ({ metadata }) => {
  return defineAction({
    type: EDITOR_HAS_CONTENT,
    metadata,
  });
};

export const setNewMessages = ({ data }) => {
  return defineAction({
    type: HAS_NEW_MESSAGES,
    payload: { data },
  });
};

export const sendMessage = ({ metadata }) => {
  return defineAction({
    type: SEND_MESSAGE,
    metadata,
  });
};

export const hasSendMessage = {
  start: () => defineAction({ type: HAS_SEND_MESSAGE.START }),
  success: ({ data }) => defineAction({ type: HAS_SEND_MESSAGE.SUCCESS, payload: { data } }),
};

export const closeSelectedConversation = {
  start: ({ payload, metadata }) =>
    defineAction({ type: CLOSE_SELECTED_CONVERSATION.START, payload, metadata }),
  success: ({ data }) =>
    defineAction({ type: CLOSE_SELECTED_CONVERSATION.SUCCESS, payload: { data } }),
  error: ({ error }) =>
    defineAction({
      type: CLOSE_SELECTED_CONVERSATION.ERROR,
      error,
    }),
};

export const setConversationRequest = {
  start: ({ payload, metadata }) =>
    defineAction({ type: SET_CONVERSATION_REQUEST.START, payload, metadata }),
  success: () => defineAction({ type: SET_CONVERSATION_REQUEST.SUCCESS }),
  error: ({ error }) =>
    defineAction({
      type: SET_CONVERSATION_REQUEST.ERROR,
      error,
    }),
};

export const getInboxDetail = {
  start: ({ metadata }) => defineAction({ type: GET_INBOX_DETAIL.START, metadata }),
  success: ({ data }) => defineAction({ type: GET_INBOX_DETAIL.SUCCESS, payload: { data } }),
  error: ({ error }) =>
    defineAction({
      type: GET_INBOX_DETAIL.ERROR,
      error,
    }),
};

export const getConversationList = {
  start: ({ metadata }) => defineAction({ type: GET_CONVERSATION_LIST.START, metadata }),
  success: ({ data }) => defineAction({ type: GET_CONVERSATION_LIST.SUCCESS, payload: { data } }),
  error: ({ error }) =>
    defineAction({
      type: GET_CONVERSATION_LIST.ERROR,
      error,
    }),
};

export const getTeamMembers = {
  start: () => defineAction({ type: GET_TEAM_MEMBERS.START }),
  success: ({ data }) => defineAction({ type: GET_TEAM_MEMBERS.SUCCESS, payload: { data } }),
  error: ({ error }) =>
    defineAction({
      type: GET_TEAM_MEMBERS.ERROR,
      error,
    }),
};

export const getConversationMembers = {
  start: ({ metadata }) => defineAction({ type: GET_CONVERSATION_MEMBERS.START, metadata }),
  success: ({ data }) =>
    defineAction({ type: GET_CONVERSATION_MEMBERS.SUCCESS, payload: { data } }),
  error: ({ error }) =>
    defineAction({
      type: GET_CONVERSATION_MEMBERS.ERROR,
      error,
    }),
};

export const removeConversationDetail = () => {
  return {
    type: REMOVE_CONVERSATION_DETAIL,
  };
};

export const getConversationListFiltered = {
  start: () => defineAction({ type: GET_CONVERSATION_LIST_FILTERED.START }),
  success: () => defineAction({ type: GET_CONVERSATION_LIST_FILTERED.SUCCESS }),
  error: () => defineAction({ type: GET_CONVERSATION_LIST_FILTERED.ERROR }),
};

export const getConversationDetail = {
  start: ({ metadata }) => defineAction({ type: GET_CONVERSATION_DETAIL.START, metadata }),
  success: ({ data }) => defineAction({ type: GET_CONVERSATION_DETAIL.SUCCESS, payload: { data } }),
  error: ({ error }) =>
    defineAction({
      type: GET_CONVERSATION_DETAIL.ERROR,
      error,
    }),
};

export const sendConversationMessages = {
  start: ({ payload, metadata }) =>
    defineAction({ type: SEND_CONVERSATION_MESSAGES.START, payload, metadata }),
  success: () => defineAction({ type: SEND_CONVERSATION_MESSAGES.SUCCESS }),
  error: ({ error }) =>
    defineAction({
      type: SEND_CONVERSATION_MESSAGES.ERROR,
      payload: {
        error,
      },
    }),
};

export const updateConversationMessages = {
  start: ({ payload, metadata }) =>
    defineAction({ type: UPDATE_CONVERSATION_MESSAGES.START, payload, metadata }),
  success: ({ data }) =>
    defineAction({ type: UPDATE_CONVERSATION_MESSAGES.SUCCESS, payload: { data } }),
};

export const startBookMeeting = {
  start: ({ metadata }) => defineAction({ type: START_BOOK_MEETING.START, metadata }),
};

export const setArchiveStarConversation = {
  start: ({ payload, metadata }) =>
    defineAction({ type: SET_ARCHIVE_STAR_CONVERSATION.START, payload, metadata }),
};

export const updateConversationList = ({ data }) => {
  return defineAction({
    type: UPDATE_CONVERSATION_LIST,
    payload: {
      data,
    },
  });
};

export const updateInboxDetailStatistics = ({ data }) => {
  return defineAction({
    type: UPDATE_INBOX_DETAIL_STATISTICS,
    payload: {
      data,
    },
  });
};

export const addNewMemberConversation = {
  start: ({ payload, metadata }) =>
    defineAction({ type: ADD_NEW_MEMBER_CONVERSATION.START, payload, metadata }),
  success: () => defineAction({ type: ADD_NEW_MEMBER_CONVERSATION.SUCCESS }),
  error: () => defineAction({ type: ADD_NEW_MEMBER_CONVERSATION.ERROR }),
};

export const removeMemberConversation = {
  start: ({ payload, metadata }) =>
    defineAction({ type: REMOVE_MEMBER_CONVERSATION.START, payload, metadata }),
  success: () => defineAction({ type: REMOVE_MEMBER_CONVERSATION.SUCCESS }),
  error: () => defineAction({ type: REMOVE_MEMBER_CONVERSATION.ERROR }),
};

export const readConversation = {
  start: ({ metadata }) => defineAction({ type: READ_CONVERSATION.START, metadata }),
};

export const updateConversationStatus = {
  start: ({ payload, metadata }) =>
    defineAction({ type: UPDATE_CONVERSATION_STATUS.START, payload, metadata }),
  success: () => defineAction({ type: UPDATE_CONVERSATION_STATUS.SUCCESS }),
  error: () => defineAction({ type: UPDATE_CONVERSATION_STATUS.ERROR }),
};

export const updateInboxData = ({ metadata }) => {
  return defineAction({
    type: UPDATE_INBOX_DATA,
    metadata,
  });
};

export const changeCurrentConversation = ({ metadata }) => {
  return defineAction({
    type: CHANGE_CURRENT_CONVERSATION,
    metadata,
  });
};

export const updateSendingMessages = ({ data }) => {
  return defineAction({
    type: UPDATE_SENDING_MESSAGES,
    payload: {
      data,
    },
  });
};

export const addToConversationList = ({ metadata }) => {
  return defineAction({
    type: ADD_TO_CONVERSATIONS_LIST,
    metadata,
  });
};

export const removeFromConversationList = ({ metadata }) => {
  return defineAction({
    type: REMOVE_FROM_CONVERSATIONS_LIST,
    metadata,
  });
};

export const getUserStatus = {
  start: () => defineAction({ type: GET_USER_STATUS.START }),
  success: ({ data }) => defineAction({ type: GET_USER_STATUS.SUCCESS, payload: { data } }),
  error: () => defineAction({ type: GET_USER_STATUS.ERROR }),
};

export const updateUserStatus = {
  start: ({ payload, metadata }) =>
    defineAction({ type: UPDATE_USER_STATUS.START, payload, metadata }),
  success: ({ data }) => defineAction({ type: UPDATE_USER_STATUS.SUCCESS, payload: { data } }),
  error: () => defineAction({ type: UPDATE_USER_STATUS.ERROR }),
};

export const loadingNewConversation = () => {
  return defineAction({ type: LOADING_NEW_CONVERSATION });
};

export const getConversationFromParams = {
  start: ({ metadata }) => defineAction({ type: GET_CONVERSATION_FROM_PARAMS.START, metadata }),
  success: () => defineAction({ type: GET_CONVERSATION_FROM_PARAMS.SUCCESS }),
  error: () => defineAction({ type: GET_CONVERSATION_FROM_PARAMS.ERROR }),
};

export const handleMessageSendingToPusher = ({ metadata }) => {
  return defineAction({
    type: HANDLE_SENDING_MESSAGE_TO_PUSHER,
    metadata,
  });
};

export const removeFromSendingMessages = ({ metadata }) => {
  return defineAction({
    type: REMOVE_FROM_SENDING_MESSAGES,
    metadata,
  });
};

export const updateLastVisitorReadTime = ({ data }) => {
  return defineAction({
    type: UPDATE_MESSAGE_READ_STATUS,
    payload: {
      data,
    },
  });
};

export const updateLastVisitorDeliveredTime = ({ data }) => {
  return defineAction({
    type: UPDATE_MESSAGE_DELIVERED,
    payload: {
      data,
    },
  });
};

export const isUpdateConversationLists = ({ data, type }) => {
  return defineAction({
    type: IS_UPDATE_CONVERSATION_LISTS,
    payload: {
      data,
      type,
    },
  });
};

export const changeZendeskInboxActiveTab = tabIndex => {
  return {
    type: CHANGE_ZENDESK_INBOX_ACTIVE_TAB,
    tabIndex,
  };
};

export const createZendeskTicket = {
  start: ({ payload }) => defineAction({ type: CREATE_ZENDESK_TICKET.START, payload }),
  success: ({ data }) => defineAction({ type: CREATE_ZENDESK_TICKET.SUCCESS, payload: { data } }),
  error: ({ errorMessage }) => defineAction({ type: CREATE_ZENDESK_TICKET.ERROR, errorMessage }),
};

export const getKnowledgeBaseArticles = {
  start: ({ metadata }) => defineAction({ type: GET_KNOWLEDGE_BASE_ARTICLES.START, metadata }),
  success: ({ data }) =>
    defineAction({ type: GET_KNOWLEDGE_BASE_ARTICLES.SUCCESS, payload: { data } }),
  error: ({ errorMessage }) =>
    defineAction({ type: GET_KNOWLEDGE_BASE_ARTICLES.ERROR, errorMessage }),
};

export const getConnectedApps = {
  start: () => defineAction({ type: GET_CONNECTED_APPS.START }),
  success: ({ data }) =>
    defineAction({
      type: GET_CONNECTED_APPS.SUCCESS,
      payload: {
        data,
      },
    }),
  error: () =>
    defineAction({
      type: GET_CONNECTED_APPS.ERROR,
    }),
};

export const logoutUser = {
  start: ({ metadata }) => defineAction({ type: LOGOUT_USER.START, metadata }),
  success: ({ data }) => defineAction({ type: LOGOUT_USER.SUCCESS, payload: { data } }),
  error: ({ error }) => defineAction({ type: LOGOUT_USER.ERROR, payload: { error } }),
};

export const updateInboxStatistics = {
  success: ({ payload }) => defineAction({ type: UPDATE_INBOX_STATISTICS.SUCCESS, payload }),
};

export const updateConversationsRead = {
  start: () => defineAction({ type: UPDATE_CONVERSATIONS_READ.START }),
  success: ({ payload }) => defineAction({ type: UPDATE_CONVERSATIONS_READ.SUCCESS, payload }),
};

export const updateSelectedFilters = {
  start: () => defineAction({ type: UPDATE_SELECTED_FILTERS.START }),
  success: ({ payload }) => defineAction({ type: UPDATE_SELECTED_FILTERS.SUCCESS, payload }),
};

export const changedServiceCloudActiveTab = tabIndex => {
  return {
    type: CHANGE_SERVICE_CLOUD_ACTIVE_TAB,
    tabIndex,
  };
};

export const createServiceCloudCase = {
  start: ({ payload }) => defineAction({ type: CREATE_SERVICE_CLOUD_CASE.START, payload }),
  success: ({ data }) =>
    defineAction({ type: CREATE_SERVICE_CLOUD_CASE.SUCCESS, payload: { data } }),
  error: ({ errorMessage }) =>
    defineAction({ type: CREATE_SERVICE_CLOUD_CASE.ERROR, errorMessage }),
};

export const getServiceCloudArticles = {
  start: ({ metadata }) => defineAction({ type: GET_SERVICE_CLOUD_ARTICLES.START, metadata }),
  success: ({ data }) =>
    defineAction({ type: GET_SERVICE_CLOUD_ARTICLES.SUCCESS, payload: { data } }),
  error: ({ errorMessage }) =>
    defineAction({ type: GET_SERVICE_CLOUD_ARTICLES.ERROR, errorMessage }),
};

export const blockVisitor = {
  start: ({ metadata, payload }) => defineAction({ type: BLOCK_VISITOR.START, metadata, payload }),
  success: ({ data }) => defineAction({ type: BLOCK_VISITOR.SUCCESS, payload: { data } }),
  error: ({ error }) => defineAction({ type: BLOCK_VISITOR.ERROR, error }),
};

export const openVisitorBlockModal = ({ showModal }) =>
  defineAction({
    type: OPEN_VISITOR_BLOCK_MODAL,
    payload: {
      showModal,
    },
  });
export const getTags = {
  start: () => defineAction({ type: GET_TAGS.START }),
  success: ({ data }) => defineAction({ type: GET_TAGS.SUCCESS, payload: { data } }),
  error: ({ error }) => defineAction({ type: GET_TAGS.ERROR, error }),
};

export const getSubscriptionDetails = {
  start: () => defineAction({ type: GET_SUBSCRIPTION_DETAILS.START }),
  success: ({ data }) =>
    defineAction({ type: GET_SUBSCRIPTION_DETAILS.SUCCESS, payload: { data } }),
  error: ({ error }) => defineAction({ type: GET_SUBSCRIPTION_DETAILS.ERROR, error }),
};

export const getHighlightsFields = {
  start: ({ metadata }) => defineAction({ type: GET_HIGHLIGHTS_FIELDS.START, metadata }),
  success: ({ data }) => defineAction({ type: GET_HIGHLIGHTS_FIELDS.SUCCESS, payload: { data } }),
  error: ({ error }) => defineAction({ type: GET_HIGHLIGHTS_FIELDS.ERROR, error }),
};

export const getHighlightsTemplates = {
  start: () => defineAction({ type: GET_HIGHLIGHTS_TEMPLATES.START }),
  success: ({ data }) =>
    defineAction({ type: GET_HIGHLIGHTS_TEMPLATES.SUCCESS, payload: { data } }),
  error: ({ error }) => defineAction({ type: GET_HIGHLIGHTS_TEMPLATES.ERROR, error }),
};

export const saveHighlightsBuilder = {
  start: ({ metadata, payload }) =>
    defineAction({ type: SAVE_HIGHLIGHTS_BUILDER.START, metadata, payload }),
  success: ({ data }) => defineAction({ type: SAVE_HIGHLIGHTS_BUILDER.SUCCESS, payload: { data } }),
  error: ({ error }) => defineAction({ type: SAVE_HIGHLIGHTS_BUILDER.ERROR, error }),
};

export const updateSelectedFieldsCount = ({ data }) =>
  defineAction({
    type: UPDATE_SELECTED_FIELDS_COUNT,
    payload: {
      data,
    },
  });

export const updateConversationListFilters = ({ data }) =>
  defineAction({
    type: UPDATE_CONVERSATION_LIST_FILTERS,
    payload: {
      data,
    },
  });

export const getAttachments = {
  start: () => defineAction({ type: GET_ATTACHMENTS.START }),
  success: ({ data }) => defineAction({ type: GET_ATTACHMENTS.SUCCESS, payload: { data } }),
  error: ({ error }) => defineAction({ type: GET_ATTACHMENTS.ERROR, error }),
};

export const updateAttachments = files =>
  defineAction({
    type: UPDATE_ATTACHMENTS,
    payload: {
      files,
    },
  });

export const updateUploadProgress = {
  start: ({ metadata }) => defineAction({ type: UPDATE_UPLOAD_PROGRESS.START, metadata }),
  success: ({ data }) => defineAction({ type: UPDATE_UPLOAD_PROGRESS.SUCCESS, payload: { data } }),
  error: ({ data }) => defineAction({ type: UPDATE_UPLOAD_PROGRESS.ERROR, payload: { data } }),
};
